export const getUserInfo = (store) => {
    const BusinessID = store.state.User.user.business[0].id;
    const UserID = store.state.User.user.id;
    return { BusinessID, UserID };
  };